/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Unified Android Exam APIs
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AssessmentsRequest,
  AttemptMockTestRequest,
  AttemptMockTestResponse,
  ExamDetailsResponse,
  ExamStartResponse,
  GeneralInstructionRequest,
  GeneralInstructionResponse,
  GetCohortScheduleResponse,
  GetQuestionsParams,
  GetRulesResponse,
  OneAmsSubmitExamRequest,
  OneAsmExamSubimtResponse,
  OneAsmQuestionsResponse,
  OneAsmUserResponse,
  QuestionsRequest,
  QuestionsResponse,
  SaveStudentAnswers200,
  SaveStudentRequest,
  SaveUserAnsRequest,
  SaveUserAnsResponse,
  StartExamRequest,
  SubmitRequest,
  SubmitResponse,
  TimeStampResponse,
  UserSelectedAnswersRequest,
  UserSelectedAnswersResponse,
} from ".././model";

import { customInstance } from "../../../api-client";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Start an exam
 */
export const startExam = (
  startExamRequest: StartExamRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<ExamStartResponse>(
    {
      url: `/exams/startExam`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: startExamRequest,
      signal,
    },
    options,
  );
};

export const getStartExamMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startExam>>,
    TError,
    { data: StartExamRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof startExam>>,
  TError,
  { data: StartExamRequest },
  TContext
> => {
  const mutationKey = ["startExam"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof startExam>>,
    { data: StartExamRequest }
  > = (props) => {
    const { data } = props ?? {};

    return startExam(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StartExamMutationResult = NonNullable<
  Awaited<ReturnType<typeof startExam>>
>;
export type StartExamMutationBody = StartExamRequest;
export type StartExamMutationError = unknown;

/**
 * @summary Start an exam
 */
export const useStartExam = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof startExam>>,
      TError,
      { data: StartExamRequest },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof startExam>>,
  TError,
  { data: StartExamRequest },
  TContext
> => {
  const mutationOptions = getStartExamMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get exam instructions
 */
export const getExamInstructions = (
  examId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<ExamDetailsResponse>(
    { url: `/exams/${examId}`, method: "GET", signal },
    options,
  );
};

export const getGetExamInstructionsQueryKey = (examId?: string) => {
  return [`/exams/${examId}`] as const;
};

export const getGetExamInstructionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getExamInstructions>>,
  TError = unknown,
>(
  examId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExamInstructions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetExamInstructionsQueryKey(examId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getExamInstructions>>
  > = ({ signal }) => getExamInstructions(examId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!examId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getExamInstructions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetExamInstructionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getExamInstructions>>
>;
export type GetExamInstructionsQueryError = unknown;

export function useGetExamInstructions<
  TData = Awaited<ReturnType<typeof getExamInstructions>>,
  TError = unknown,
>(
  examId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExamInstructions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExamInstructions>>,
          TError,
          Awaited<ReturnType<typeof getExamInstructions>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetExamInstructions<
  TData = Awaited<ReturnType<typeof getExamInstructions>>,
  TError = unknown,
>(
  examId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExamInstructions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExamInstructions>>,
          TError,
          Awaited<ReturnType<typeof getExamInstructions>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetExamInstructions<
  TData = Awaited<ReturnType<typeof getExamInstructions>>,
  TError = unknown,
>(
  examId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExamInstructions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get exam instructions
 */

export function useGetExamInstructions<
  TData = Awaited<ReturnType<typeof getExamInstructions>>,
  TError = unknown,
>(
  examId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExamInstructions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetExamInstructionsQueryOptions(examId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get user response for exam
 */
export const getUserResponse = (
  examId: string,
  studentId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<OneAsmUserResponse>(
    { url: `/exams/${examId}/${studentId}`, method: "GET", signal },
    options,
  );
};

export const getGetUserResponseQueryKey = (
  examId?: string,
  studentId?: string,
) => {
  return [`/exams/${examId}/${studentId}`] as const;
};

export const getGetUserResponseQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserResponse>>,
  TError = unknown,
>(
  examId: string,
  studentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserResponse>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetUserResponseQueryKey(examId, studentId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserResponse>>> = ({
    signal,
  }) => getUserResponse(examId, studentId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(examId && studentId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserResponse>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUserResponseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserResponse>>
>;
export type GetUserResponseQueryError = unknown;

export function useGetUserResponse<
  TData = Awaited<ReturnType<typeof getUserResponse>>,
  TError = unknown,
>(
  examId: string,
  studentId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserResponse>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserResponse>>,
          TError,
          Awaited<ReturnType<typeof getUserResponse>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserResponse<
  TData = Awaited<ReturnType<typeof getUserResponse>>,
  TError = unknown,
>(
  examId: string,
  studentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserResponse>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserResponse>>,
          TError,
          Awaited<ReturnType<typeof getUserResponse>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserResponse<
  TData = Awaited<ReturnType<typeof getUserResponse>>,
  TError = unknown,
>(
  examId: string,
  studentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserResponse>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get user response for exam
 */

export function useGetUserResponse<
  TData = Awaited<ReturnType<typeof getUserResponse>>,
  TError = unknown,
>(
  examId: string,
  studentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserResponse>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetUserResponseQueryOptions(
    examId,
    studentId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Submit exam (OneAsm)
 */
export const submitExam = (
  oneAmsSubmitExamRequest: OneAmsSubmitExamRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<OneAsmExamSubimtResponse>(
    {
      url: `/exams/submitExam`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: oneAmsSubmitExamRequest,
      signal,
    },
    options,
  );
};

export const getSubmitExamMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitExam>>,
    TError,
    { data: OneAmsSubmitExamRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof submitExam>>,
  TError,
  { data: OneAmsSubmitExamRequest },
  TContext
> => {
  const mutationKey = ["submitExam"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitExam>>,
    { data: OneAmsSubmitExamRequest }
  > = (props) => {
    const { data } = props ?? {};

    return submitExam(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SubmitExamMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitExam>>
>;
export type SubmitExamMutationBody = OneAmsSubmitExamRequest;
export type SubmitExamMutationError = unknown;

/**
 * @summary Submit exam (OneAsm)
 */
export const useSubmitExam = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof submitExam>>,
      TError,
      { data: OneAmsSubmitExamRequest },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof submitExam>>,
  TError,
  { data: OneAmsSubmitExamRequest },
  TContext
> => {
  const mutationOptions = getSubmitExamMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Save student answers (OneAsm)
 */
export const saveStudentAnswers = (
  saveStudentRequest: SaveStudentRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<SaveStudentAnswers200>(
    {
      url: `/exams/saveStudentAnswers`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: saveStudentRequest,
      signal,
    },
    options,
  );
};

export const getSaveStudentAnswersMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveStudentAnswers>>,
    TError,
    { data: SaveStudentRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveStudentAnswers>>,
  TError,
  { data: SaveStudentRequest },
  TContext
> => {
  const mutationKey = ["saveStudentAnswers"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveStudentAnswers>>,
    { data: SaveStudentRequest }
  > = (props) => {
    const { data } = props ?? {};

    return saveStudentAnswers(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SaveStudentAnswersMutationResult = NonNullable<
  Awaited<ReturnType<typeof saveStudentAnswers>>
>;
export type SaveStudentAnswersMutationBody = SaveStudentRequest;
export type SaveStudentAnswersMutationError = unknown;

/**
 * @summary Save student answers (OneAsm)
 */
export const useSaveStudentAnswers = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof saveStudentAnswers>>,
      TError,
      { data: SaveStudentRequest },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof saveStudentAnswers>>,
  TError,
  { data: SaveStudentRequest },
  TContext
> => {
  const mutationOptions = getSaveStudentAnswersMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get question paper
 */
export const getQuestionPaper = (
  assetId: string,
  mode: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<OneAsmQuestionsResponse>(
    {
      url: `/asset/getAssetFromS3/question_paper/${assetId}/${mode}`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getGetQuestionPaperQueryKey = (
  assetId?: string,
  mode?: string,
) => {
  return [`/asset/getAssetFromS3/question_paper/${assetId}/${mode}`] as const;
};

export const getGetQuestionPaperQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuestionPaper>>,
  TError = unknown,
>(
  assetId: string,
  mode: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuestionPaper>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetQuestionPaperQueryKey(assetId, mode);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getQuestionPaper>>
  > = ({ signal }) => getQuestionPaper(assetId, mode, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(assetId && mode),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getQuestionPaper>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetQuestionPaperQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuestionPaper>>
>;
export type GetQuestionPaperQueryError = unknown;

export function useGetQuestionPaper<
  TData = Awaited<ReturnType<typeof getQuestionPaper>>,
  TError = unknown,
>(
  assetId: string,
  mode: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuestionPaper>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuestionPaper>>,
          TError,
          Awaited<ReturnType<typeof getQuestionPaper>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetQuestionPaper<
  TData = Awaited<ReturnType<typeof getQuestionPaper>>,
  TError = unknown,
>(
  assetId: string,
  mode: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuestionPaper>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getQuestionPaper>>,
          TError,
          Awaited<ReturnType<typeof getQuestionPaper>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetQuestionPaper<
  TData = Awaited<ReturnType<typeof getQuestionPaper>>,
  TError = unknown,
>(
  assetId: string,
  mode: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuestionPaper>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get question paper
 */

export function useGetQuestionPaper<
  TData = Awaited<ReturnType<typeof getQuestionPaper>>,
  TError = unknown,
>(
  assetId: string,
  mode: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getQuestionPaper>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetQuestionPaperQueryOptions(assetId, mode, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get exam questions (with solutions)
 */
export const getQuestions = (
  questionsRequest: QuestionsRequest,
  params?: GetQuestionsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<QuestionsResponse>(
    {
      url: `/exam/questions/`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: questionsRequest,
      params,
      signal,
    },
    options,
  );
};

export const getGetQuestionsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getQuestions>>,
    TError,
    { data: QuestionsRequest; params?: GetQuestionsParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getQuestions>>,
  TError,
  { data: QuestionsRequest; params?: GetQuestionsParams },
  TContext
> => {
  const mutationKey = ["getQuestions"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getQuestions>>,
    { data: QuestionsRequest; params?: GetQuestionsParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return getQuestions(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetQuestionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof getQuestions>>
>;
export type GetQuestionsMutationBody = QuestionsRequest;
export type GetQuestionsMutationError = unknown;

/**
 * @summary Get exam questions (with solutions)
 */
export const useGetQuestions = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getQuestions>>,
      TError,
      { data: QuestionsRequest; params?: GetQuestionsParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof getQuestions>>,
  TError,
  { data: QuestionsRequest; params?: GetQuestionsParams },
  TContext
> => {
  const mutationOptions = getGetQuestionsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get assessments (rules V2)
 */
export const getAssessments = (
  assessmentsRequest: AssessmentsRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<GetRulesResponse>(
    {
      url: `/getrulesV2/`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: assessmentsRequest,
      signal,
    },
    options,
  );
};

export const getGetAssessmentsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getAssessments>>,
    TError,
    { data: AssessmentsRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getAssessments>>,
  TError,
  { data: AssessmentsRequest },
  TContext
> => {
  const mutationKey = ["getAssessments"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getAssessments>>,
    { data: AssessmentsRequest }
  > = (props) => {
    const { data } = props ?? {};

    return getAssessments(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetAssessmentsMutationResult = NonNullable<
  Awaited<ReturnType<typeof getAssessments>>
>;
export type GetAssessmentsMutationBody = AssessmentsRequest;
export type GetAssessmentsMutationError = unknown;

/**
 * @summary Get assessments (rules V2)
 */
export const useGetAssessments = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getAssessments>>,
      TError,
      { data: AssessmentsRequest },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof getAssessments>>,
  TError,
  { data: AssessmentsRequest },
  TContext
> => {
  const mutationOptions = getGetAssessmentsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Submit exam (legacy)
 */
export const submitTest = (
  submitRequest: SubmitRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<SubmitResponse>(
    {
      url: `/exam/submitExam/`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: submitRequest,
      signal,
    },
    options,
  );
};

export const getSubmitTestMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitTest>>,
    TError,
    { data: SubmitRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof submitTest>>,
  TError,
  { data: SubmitRequest },
  TContext
> => {
  const mutationKey = ["submitTest"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitTest>>,
    { data: SubmitRequest }
  > = (props) => {
    const { data } = props ?? {};

    return submitTest(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SubmitTestMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitTest>>
>;
export type SubmitTestMutationBody = SubmitRequest;
export type SubmitTestMutationError = unknown;

/**
 * @summary Submit exam (legacy)
 */
export const useSubmitTest = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof submitTest>>,
      TError,
      { data: SubmitRequest },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof submitTest>>,
  TError,
  { data: SubmitRequest },
  TContext
> => {
  const mutationOptions = getSubmitTestMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Save single user answer
 */
export const getSaveUserAnswer = (
  saveUserAnsRequest: SaveUserAnsRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<SaveUserAnsResponse>(
    {
      url: `/exam/userresponseData/`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: saveUserAnsRequest,
      signal,
    },
    options,
  );
};

export const getGetSaveUserAnswerMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getSaveUserAnswer>>,
    TError,
    { data: SaveUserAnsRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getSaveUserAnswer>>,
  TError,
  { data: SaveUserAnsRequest },
  TContext
> => {
  const mutationKey = ["getSaveUserAnswer"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getSaveUserAnswer>>,
    { data: SaveUserAnsRequest }
  > = (props) => {
    const { data } = props ?? {};

    return getSaveUserAnswer(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetSaveUserAnswerMutationResult = NonNullable<
  Awaited<ReturnType<typeof getSaveUserAnswer>>
>;
export type GetSaveUserAnswerMutationBody = SaveUserAnsRequest;
export type GetSaveUserAnswerMutationError = unknown;

/**
 * @summary Save single user answer
 */
export const useGetSaveUserAnswer = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getSaveUserAnswer>>,
      TError,
      { data: SaveUserAnsRequest },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof getSaveUserAnswer>>,
  TError,
  { data: SaveUserAnsRequest },
  TContext
> => {
  const mutationOptions = getGetSaveUserAnswerMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Save multiple user answers
 */
export const getSaveMultipleUserAnswer = (
  saveUserAnsRequest: SaveUserAnsRequest[],
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<SaveUserAnsResponse[]>(
    {
      url: `/exam/multipleUserResponseData/`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: saveUserAnsRequest,
      signal,
    },
    options,
  );
};

export const getGetSaveMultipleUserAnswerMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getSaveMultipleUserAnswer>>,
    TError,
    { data: SaveUserAnsRequest[] },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getSaveMultipleUserAnswer>>,
  TError,
  { data: SaveUserAnsRequest[] },
  TContext
> => {
  const mutationKey = ["getSaveMultipleUserAnswer"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getSaveMultipleUserAnswer>>,
    { data: SaveUserAnsRequest[] }
  > = (props) => {
    const { data } = props ?? {};

    return getSaveMultipleUserAnswer(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetSaveMultipleUserAnswerMutationResult = NonNullable<
  Awaited<ReturnType<typeof getSaveMultipleUserAnswer>>
>;
export type GetSaveMultipleUserAnswerMutationBody = SaveUserAnsRequest[];
export type GetSaveMultipleUserAnswerMutationError = unknown;

/**
 * @summary Save multiple user answers
 */
export const useGetSaveMultipleUserAnswer = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getSaveMultipleUserAnswer>>,
      TError,
      { data: SaveUserAnsRequest[] },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof getSaveMultipleUserAnswer>>,
  TError,
  { data: SaveUserAnsRequest[] },
  TContext
> => {
  const mutationOptions = getGetSaveMultipleUserAnswerMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get saved user responses
 */
export const getUserResponseData = (
  userSelectedAnswersRequest: UserSelectedAnswersRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<UserSelectedAnswersResponse>(
    {
      url: `/exam/getUserResponseData/`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: userSelectedAnswersRequest,
      signal,
    },
    options,
  );
};

export const getGetUserResponseDataMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getUserResponseData>>,
    TError,
    { data: UserSelectedAnswersRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getUserResponseData>>,
  TError,
  { data: UserSelectedAnswersRequest },
  TContext
> => {
  const mutationKey = ["getUserResponseData"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getUserResponseData>>,
    { data: UserSelectedAnswersRequest }
  > = (props) => {
    const { data } = props ?? {};

    return getUserResponseData(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetUserResponseDataMutationResult = NonNullable<
  Awaited<ReturnType<typeof getUserResponseData>>
>;
export type GetUserResponseDataMutationBody = UserSelectedAnswersRequest;
export type GetUserResponseDataMutationError = unknown;

/**
 * @summary Get saved user responses
 */
export const useGetUserResponseData = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getUserResponseData>>,
      TError,
      { data: UserSelectedAnswersRequest },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof getUserResponseData>>,
  TError,
  { data: UserSelectedAnswersRequest },
  TContext
> => {
  const mutationOptions = getGetUserResponseDataMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get server timestamp
 */
export const getServerTimeStamp = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<TimeStampResponse>(
    { url: `/exam/gettimestamp/`, method: "GET", signal },
    options,
  );
};

export const getGetServerTimeStampQueryKey = () => {
  return [`/exam/gettimestamp/`] as const;
};

export const getGetServerTimeStampQueryOptions = <
  TData = Awaited<ReturnType<typeof getServerTimeStamp>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getServerTimeStamp>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetServerTimeStampQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getServerTimeStamp>>
  > = ({ signal }) => getServerTimeStamp(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getServerTimeStamp>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetServerTimeStampQueryResult = NonNullable<
  Awaited<ReturnType<typeof getServerTimeStamp>>
>;
export type GetServerTimeStampQueryError = unknown;

export function useGetServerTimeStamp<
  TData = Awaited<ReturnType<typeof getServerTimeStamp>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getServerTimeStamp>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServerTimeStamp>>,
          TError,
          Awaited<ReturnType<typeof getServerTimeStamp>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetServerTimeStamp<
  TData = Awaited<ReturnType<typeof getServerTimeStamp>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getServerTimeStamp>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServerTimeStamp>>,
          TError,
          Awaited<ReturnType<typeof getServerTimeStamp>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetServerTimeStamp<
  TData = Awaited<ReturnType<typeof getServerTimeStamp>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getServerTimeStamp>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get server timestamp
 */

export function useGetServerTimeStamp<
  TData = Awaited<ReturnType<typeof getServerTimeStamp>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getServerTimeStamp>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetServerTimeStampQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get general exam instructions
 */
export const getGeneralInstructions = (
  generalInstructionRequest: GeneralInstructionRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<GeneralInstructionResponse>(
    {
      url: `/exam/examInstructions/`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: generalInstructionRequest,
      signal,
    },
    options,
  );
};

export const getGetGeneralInstructionsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getGeneralInstructions>>,
    TError,
    { data: GeneralInstructionRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getGeneralInstructions>>,
  TError,
  { data: GeneralInstructionRequest },
  TContext
> => {
  const mutationKey = ["getGeneralInstructions"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getGeneralInstructions>>,
    { data: GeneralInstructionRequest }
  > = (props) => {
    const { data } = props ?? {};

    return getGeneralInstructions(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetGeneralInstructionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof getGeneralInstructions>>
>;
export type GetGeneralInstructionsMutationBody = GeneralInstructionRequest;
export type GetGeneralInstructionsMutationError = unknown;

/**
 * @summary Get general exam instructions
 */
export const useGetGeneralInstructions = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getGeneralInstructions>>,
      TError,
      { data: GeneralInstructionRequest },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof getGeneralInstructions>>,
  TError,
  { data: GeneralInstructionRequest },
  TContext
> => {
  const mutationOptions = getGetGeneralInstructionsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Create/attempt mock test
 */
export const attemptMockTest = (
  attemptMockTestRequest: AttemptMockTestRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<AttemptMockTestResponse>(
    {
      url: `/learner/createMockTest`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: attemptMockTestRequest,
      signal,
    },
    options,
  );
};

export const getAttemptMockTestMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof attemptMockTest>>,
    TError,
    { data: AttemptMockTestRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof attemptMockTest>>,
  TError,
  { data: AttemptMockTestRequest },
  TContext
> => {
  const mutationKey = ["attemptMockTest"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof attemptMockTest>>,
    { data: AttemptMockTestRequest }
  > = (props) => {
    const { data } = props ?? {};

    return attemptMockTest(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AttemptMockTestMutationResult = NonNullable<
  Awaited<ReturnType<typeof attemptMockTest>>
>;
export type AttemptMockTestMutationBody = AttemptMockTestRequest;
export type AttemptMockTestMutationError = unknown;

/**
 * @summary Create/attempt mock test
 */
export const useAttemptMockTest = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof attemptMockTest>>,
      TError,
      { data: AttemptMockTestRequest },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof attemptMockTest>>,
  TError,
  { data: AttemptMockTestRequest },
  TContext
> => {
  const mutationOptions = getAttemptMockTestMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get cohort schedule
 */
export const getCohortSchedule = (
  cohortAsmId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<GetCohortScheduleResponse>(
    {
      url: `/learner/getCohortSchedules/${cohortAsmId}`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getGetCohortScheduleQueryKey = (cohortAsmId?: string) => {
  return [`/learner/getCohortSchedules/${cohortAsmId}`] as const;
};

export const getGetCohortScheduleQueryOptions = <
  TData = Awaited<ReturnType<typeof getCohortSchedule>>,
  TError = unknown,
>(
  cohortAsmId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCohortSchedule>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCohortScheduleQueryKey(cohortAsmId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCohortSchedule>>
  > = ({ signal }) => getCohortSchedule(cohortAsmId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!cohortAsmId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCohortSchedule>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCohortScheduleQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCohortSchedule>>
>;
export type GetCohortScheduleQueryError = unknown;

export function useGetCohortSchedule<
  TData = Awaited<ReturnType<typeof getCohortSchedule>>,
  TError = unknown,
>(
  cohortAsmId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCohortSchedule>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCohortSchedule>>,
          TError,
          Awaited<ReturnType<typeof getCohortSchedule>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCohortSchedule<
  TData = Awaited<ReturnType<typeof getCohortSchedule>>,
  TError = unknown,
>(
  cohortAsmId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCohortSchedule>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCohortSchedule>>,
          TError,
          Awaited<ReturnType<typeof getCohortSchedule>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCohortSchedule<
  TData = Awaited<ReturnType<typeof getCohortSchedule>>,
  TError = unknown,
>(
  cohortAsmId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCohortSchedule>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get cohort schedule
 */

export function useGetCohortSchedule<
  TData = Awaited<ReturnType<typeof getCohortSchedule>>,
  TError = unknown,
>(
  cohortAsmId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCohortSchedule>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetCohortScheduleQueryOptions(cohortAsmId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
